module.exports = __webpack_public_path__ + "static/media/corevalue.069327bd.png";